import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import cover2 from "../Navbar/cover2.webp";
import cover3 from "../Navbar/cover3.jpg";
import cover4 from "../Navbar/cover4.jpg";
import classes from "../Carousel/Carousel.module.css";
import sq from "../Carousel/sq.jpg";
import sql from "../Carousel/sql.jpg";


function Slide(){
    return(

        <div>
            {/* phone carousal */}
            <Carousel id={classes.phone}  className={classes.caro} >
                <Carousel.Item classname={classes.slideImage}>
                    <img className={classes.im}
                    
                    src={sq}
                    alt="First slide"
                    
                    
                    />
                   
                </Carousel.Item>
                <Carousel.Item   classname={classes.slideImage}>
                    <img 
                    className={classes.im}
                    src={cover4}
                    alt="Second slide"
                    />

                 
                </Carousel.Item>
                {/* <Carousel.Item classname={classes.slideImage}>
                    <img 
                    className={classes.im}
                   
                    src={sq}
                    alt="Third slide"
                    
                    />

                 
                </Carousel.Item> */}
                </Carousel>


                {/* laptop Carousal */}

                  
        <Carousel id={classes.laptop} className={classes.caro} >
                <Carousel.Item classname={classes.slideImage}>
                    <img className={classes.im}
                    
                    src={cover4}
                    alt="First slide"
                    
                    
                    />
                   
                </Carousel.Item>
                {/* <Carousel.Item classname={classes.slideImage}>
                    <img 
                    className={classes.im}
                    src={sq}
                    alt="Second slide"
                    />

                 
                </Carousel.Item> */}
                {/* <Carousel.Item classname={classes.slideImage}>
                    <img 
                    className={classes.im}
                   
                    src={sq}
                    alt="Third slide"
                    
                    />

                 
                </Carousel.Item> */}
                </Carousel>


        </div>
   
      

                


    )
}

export default Slide;